import SvgGradInitializer from './SvgGradInitializer';

export const SVG_GRAD_ID_ONE = 'svg-grad-one';
export const SVG_GRAD_ONE = `url(#${SVG_GRAD_ID_ONE})`;

export { SvgGradInitializer };
